// extracted by mini-css-extract-plugin
module.exports = {"delete":"PhotoDelete_delete__2Kdo7"};